import axios from "axios";
import { authHeaders } from "./apiToken";

export interface Payload {
  [key: string]: any;
}

const expressAPI = async (endpoint: string, payload: Payload) => {
  const baseURL = "https://process-api-01.azure-api.net/expressapi/";
  const url = `${baseURL}${endpoint}`;

  try {
    const config = { headers: await authHeaders() };

    const response = await axios.post(url, payload, config);

    return response.data;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
};

export default expressAPI;
